import Smart from "./smart";
import { BreakpointManager } from "./plugins/smart-breakpoints";
import { MediaQueryManager } from "./plugins/smart-mediaqueries";
import { SmartJss } from "./plugins/smart-jss";
import { SmartGrids, SmartGridBreakpints } from "./plugins/smart-grid";



const instance = new Smart();
instance.use(new SmartJss())
instance.use(new MediaQueryManager())
instance.use(new SmartGrids())
instance.use(new BreakpointManager(), {plugins:[new SmartGridBreakpints()]});

export default instance;